import { getCurrentSolution } from "api/solutions";
import { getExtractedPath } from "utilities/extractedPath";
import extractUUIDs from "components/layout/utils/extractUUIDs";

const getProjectCoordinates = async () => {

  const baseUrl = getExtractedPath();
  const { currOrg, curSol } = extractUUIDs(baseUrl);

  const response = await getCurrentSolution(currOrg, curSol);
  if (response.status === 200) {
    return response.data.data.coordinates;
  }
};

export default getProjectCoordinates;